<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <PageHeader :title="title" :items="items"/>

        <b-card>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>EP ID</th>
                <th>Name</th>
                <th>Father Name</th>
                <th>Mouza</th>
                <th>Upazilla</th>
                <th>District</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(ep_list, index) in ep_lists" :key="index">
                <td>{{ ep_list.id }}</td>
                <td>{{ ep_list.ep_id ? ep_list.ep_id.ep_id : ''}}</td>
                <td>{{ ep_list.name }}</td>
                <td>{{ ep_list.father_husband_name }}</td>
                <td>{{ ep_list.mouza ? ep_list.mouza.mouza_desc : '' }}</td>
                <td>{{ ep_list.upazila ? ep_list.upazila.upazila_desc : '' }}</td>
                <td>{{ ep_list.district ? ep_list.district.district_desc : '' }}</td>
              </tr>
              </tbody>
            </table>

            <h5 class="text-center text-secondary" v-if="ep_lists.total === 0 || !flag">
              No Data Found
            </h5>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Number Of EP Lists",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Number Of EP Lists",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Number Of EP",
          active: true
        }
      ],
      ep_lists: {},
      jvc_id:'',
      flag: false,
      loader: false
    };
  },

  mounted() {
    this.jvc_id = this.$route.params.jvc_id;
    this.search();
  },
  methods: {
    search() {
      this.flag = true
      this.loader = true
      http.get("api/jvc/num-ep/" + this.jvc_id).then(response => {
        if (!response.error) {
          this.flag = true;
          this.loader = false
          this.ep_lists = response.data.ep_lists;
        }
      });
    },
  },
  computed: {
    userPermission () {
      return this.$store.state.user
    },
  },
  created () {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
<style src="vue-select/dist/vue-select.css"></style>
